import React from 'react';
import { Navigate } from 'react-router-dom';
import { useWholesaleAuth } from '../../contexts/WholesaleAuthContext';

const WholesaleProtectedRoute = ({ children }) => {
  const { currentWholesaleUser, wholesaleCustomer, loading } = useWholesaleAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        fontSize: '12px',
        color: '#999',
        textTransform: 'uppercase',
        letterSpacing: '1px'
      }}>
        Loading wholesale portal...
      </div>
    );
  }

  if (!currentWholesaleUser || !wholesaleCustomer) {
    return <Navigate to="/wholesale-login" replace />;
  }

  // Ensure the customer has access (approved, demo, or trial)
  if (!['approved', 'demo', 'trial'].includes(wholesaleCustomer.status)) {
    return <Navigate to="/wholesale-login" replace />;
  }

  return children;
};

export default WholesaleProtectedRoute;